
import React from 'react';
import { withRouter, NavLink } from 'react-router-dom'

import style from './navigationItems.scss';

class navigationItems extends React.Component {
    render(){

        let navbarItem = this.props.navLinks.map((link,index)=>{
            return <NavLink 
                activeClassName={style.active}
                to={link.link}><h5 key={index} >{link.label} </h5>
                </NavLink> 
        });

        return(
            <div className= "menu">
                {navbarItem}
            </div>
        );
    }

}

export default withRouter(navigationItems);